import { IGenericJSON } from '../helpers/interface';

export class Profile {
  id: number;
  user_id: number;
  career_id: number | null;
  bio: string | null;
  profile_picture_path: string | null;
  profile_complete_percent: number;
  avatar_id: number | null;
  createdAt: Date | null;
  updatedAt: Date | null;

  constructor(data: IGenericJSON) {
    this.id = Number(data['id']);
    this.user_id = Number(data['user_id']);
    this.career_id = data['career_id'] ?? null;
    this.bio = data['bio'] ?? null;
    this.profile_picture_path = data['profile_picture_path'] ?? null;
    this.profile_complete_percent = Number(data['profile_complete_percent'] ?? 0);
    this.avatar_id = data['avatar_id'] ?? null;
    this.createdAt = data['created_at'] ? new Date(data['created_at']) : null;
    this.updatedAt = data['updated_at'] ? new Date(data['updated_at']) : null;
  }

  public static digest(data: IGenericJSON): Profile {
    return new Profile(data);
  }

  public static digestResponse(data: IGenericJSON[]): Profile[] {
    return data.map((profile) => this.digest(profile));
  }
}
